import config from "../config";
import { restartIntercom } from "./intercomUtils";
const base_url = config.base_url;

export const serverLogout = () => {
  return new Promise((resolve, reject) => {
    window.sessionStorage.clear();
    localStorage.setItem("showReferralPopup", true);
    fetch(base_url + "logout", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then((res) => {
        restartIntercom();
        resolve();
      })
      .catch((e) => {
        restartIntercom();
        reject();
      });
  });
};
